import axios from 'axios';
import { APP_NAME, APP_VERSION } from 'config';

const axiosServices = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3010/',
    headers: {
        'X-App-Name': APP_NAME || 'BuilderApp',
        'X-App-Version': APP_VERSION || '1.1.0',
    },
});

axiosServices.interceptors.response.use(
    response => response,
    error => {
        if (
            !window.location.href.includes('/resourceRequest') &&
            error.response.status === 401 &&
            !window.location.href.includes('/login')
        ) {
            window.location.pathname = '/login';
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

export default axiosServices;
